import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericQueryResult } from 'src/model/class/general classes/generic-query-result';
import { AppSettings } from 'src/components/shared-components/class/general-classes/app-settings';

@Injectable({
  providedIn: 'root'
})
export class GenericQueryService
  implements OnDestroy {
  private _logContext: string = "generic-query.service";

  /** Subscribe to events and MQTTAddresses observables */
  constructor(private _http: HttpClient) {
  }

  /** Unsubscribe from observables */
  ngOnDestroy() {
  }

  /** Get Generic Query Result via API Call, using filter as queryString */
  public GetValidatedQuery(queryString: string): Promise<GenericQueryResult> {
    queryString.replace(/\s+/g, " ");
    return this._http
      .post<GenericQueryResult>(
        environment.httpServerRoot + AppSettings.API_URL_VALIDATE_QUERY,
        { value: queryString }
      )
      .toPromise();
  }
}
